<template>
  <div class="details">
    <div class="intro">
      <h4>Phone Numbers</h4>
    </div>
    <Table
      :items="contacts"
      :attributes="tableAttributes"
      :options="tableOptions"
      @edit="editPhone"
      @head="addPhone"
    ></Table>
  </div>
</template>

<script>
import Table from '@/components/Table.vue';

export default {
  name: 'SupporterViewPhones',
  components: {
    Table,
  },

  data() {
    return {
      isLoading: false,
      contact: null,
      tableOptions: {
        edit: false,
        pages: [5],
      },
      tableAttributes: [
        { name: 'contact', label: 'Number' },
        { name: 'label', label: 'Label' },
        { name: 'isActive', label: 'Active', type: 'tick' },
        { name: 'isPrimary', label: 'Primary', type: 'tick' },
        { name: 'doNotContact', label: "Don't Contact", type: 'tick' },
      ],
    };
  },

  props: {
    contacts: Array,
    canEdit: Boolean,
  },

  methods: {
    editPhone(contact) {
      this.$emit('editContact', { type: 'phone', contact });
    },
    addPhone() {
      this.$emit('addContact', 'phone');
    },
  },
};
</script>
